import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import styled from '@emotion/styled'
import Carousel from 'react-bootstrap/Carousel'
import { Container, Form } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import theme from '../constants/theme'

export const Header = styled('div')(() => ({
  height: '6%',
  background: '#FFFFFF 0% 0% no-repeat padding-box',
  boxShadow: '0px 10px 20px #12263F08',
  justifyContent: 'space-between',
}))

export const LogoContainer = styled(Col)(() => ({
  width: '15.75rem',
  borderRight: '1px solid #F8F8FB',
  height: '100%',
}))

export const CustomOrangeButton = styled(Button)(() => ({
  background: theme.brandColorOrange,
  border: `0.063rem solid ${theme.brandColorOrange}`,
  color: theme.white,
  boxShadow: 'none !important',
  margin: '0.45rem 0',
  padding: '5px 40px',
  '&:hover': {
    background: theme.whiteButtonBackground,
    border: `0.063rem solid ${theme.brandColorOrange}`,
    color: `${theme.brandColorOrange} !important`,
  },
  '&:focus': {
    background: theme.defaultBackground,
    border: `0.063rem solid ${theme.brandColorOrange}`,
    color: `${theme.brandColorOrange} !important`,
  },
}))

export const QuestionContainer = styled('div')(() => ({
  textAlign: 'center',
  paddingBottom: '78px',
  WebkitTouchCallout: 'none',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  userSelect: 'none',
}))

export const QuestionTextContainer = styled('div')(() => ({
  textAlign: 'left',
  background: '#FFFFFF 0% 0% no-repeat padding-box',
  border: `1px solid ${theme.headersMiniTitle}`,
  borderRadius: '5px',
  padding: '9px 12px',
  fontWeight: 'bold',
  color: theme.headersMiniTitle,
  margin: '5px 0 5px 0',
  height: 'auto',
}))

// form question
export const FormContainer = styled(Container)(() => ({
  maxWidth: '80%',
  height: `calc(100vh - 113px)`,
  overflow: 'auto',
  paddingBottom: '20px',
}))

export const QuestionFormContainer = styled('div')(() => ({
  textAlign: 'left',
  padding: '9px 12px',
  fontWeight: 'bold',
  margin: '10px 0 5px 0',
}))

export const QuestionAnswerFormContainer = styled('div')(() => ({
  color: theme.headersMiniTitle,
  background: '#FFFFFF 0% 0% no-repeat padding-box',
  margin: '15px 0',
  padding: '7px 20px',
}))

// interview demo
export const WarningImg = styled('img')(() => ({
  display: 'block',
  height: 'auto',
  maxHeight: '450px',
}))

export const ButtonsContainer = styled('div')(() => ({
  textAlign: 'center',
  marginTop: '-100px',
  bottom: 0,
  left: '50%',
  right: '50%',
  zIndex: 15,
}))

export const SpeedTestContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '5px',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  transition: '0.3s',
  margin: '10px',
}))

export const LoadingMessage = styled('div')(() => ({
  fontSize: '16px',
  color: theme.brandColorOrange,
  margin: '10px',
}))

export const UploadSpeed = styled('div')(() => ({
  fontSize: '15px',
  fontWeight: 'bold',
  margin: '5px',
  display: 'flex',
  alignItems: 'center',
}))

export const SpeedIndicator = styled('div')(() => ({
  fontSize: '14px',
  fontStyle: 'italic',
  color: '#444',
  margin: '5px',
  display: 'flex',
  alignItems: 'center',
}))

export const CameraButton = styled(Button)(() => ({
  width: '50px',
  height: '50px',
  borderRadius: '50%',
}))

export const OutlineCameraButton = styled(CameraButton)(() => ({
  backgroundColor: 'transparent',
  color: theme.white,
}))

export const TestSubmitButton = styled(Button)(() => ({
  marginLeft: '5px',
  marginRight: '5px',
  backgroundColor: theme.brandColorOrange,
  color: theme.white,
  '&:hover': {
    backgroundColor: theme.headersMiniTitle,
    color: theme.white,
  },
}))

export const CarouselSVGWrapper = styled('div')(() => ({
  margin: '0 auto',
  width: '90%',
  maxWidth: '850px',
}))

// text interview
export const QuestionTableContainer = styled(Row)(() => ({
  padding: '80px 0 0 0',
  position: 'relative',
  alignItems: 'center',
  margin: '0',
}))

export const QuestionMiddleTableCell = styled('div')(() => ({
  display: 'table-cell',
  verticalAlign: 'middle',
  alignItems: 'center',
  width: '100%',
  textAlign: 'center',
}))

export const CustomQuestionContainer = styled(QuestionContainer)(() => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  textAlign: 'center',
  paddingBottom: '0',
}))

export const CustomOutlineButton = styled(Button)(() => ({
  background: theme.white,
  border: `0.063rem solid ${theme.brandColorOrange}`,
  color: theme.brandColorOrange,
  boxShadow: 'none !important',
  margin: '0.45rem 0',
  padding: '5px 40px',
  '&:hover': {
    background: theme.brandColorOrange,
    border: `0.063rem solid ${theme.brandColorOrange}`,
    color: `${theme.white} !important`,
  },
  '&:focus': {
    background: theme.brandColorOrange,
    border: `0.063rem solid ${theme.brandColorOrange}`,
    color: `${theme.white} !important`,
  },
  '&:disabled': {
    background: theme.white,
    borderColor: '#CED4DA',
    color: '#CED4DA',
  },
}))

export const ContainerWithWaves = styled('div')(() => ({
  background: theme.brandColorOrange,
  padding: '20px',
  width: 'fit-content',
  margin: '10px auto 0 auto',
  borderRadius: '100%',
  position: 'relative',
  display: 'inline-block',
}))

export const Wave = styled('div')(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  margin: 'auto',
  borderRadius: '50%',
  background: '#3393C1',
  zIndex: -10,
  animation: 'wave 2s infinite',
}))

export const IconButton = styled(Button)(() => ({
  background: 'transparent !important',
  color: `${theme.headersMiniTitle} !important`,
  border: `none !important`,
  borderRadius: '7px',
  boxShadow: 'none !important',
  margin: '0.45rem 0',
  fontSize: '1.5rem',
}))

export const TextSpeechButton = styled(Button)(() => ({
  background: 'transparent !important',
  color: theme.headersMiniTitle,
  border: `none !important`,
  boxShadow: 'none !important',
  margin: '0.45rem 0',
  fontSize: '1.5rem',
  '&:hover': {
    color: `${theme.white} !important`,
  },
}))

export const IconButtonWrapper = styled(TextSpeechButton)(() => ({
  position: 'absolute',
  color: theme.white,
  left: 0,
  top: '-5px',
  margin: 'auto',
}))

export const Footer = styled('div')(() => ({
  position: 'fixed',
  left: '0',
  padding: `calc(${theme.gridGutterWidth} / 2)`,
  right: '0',
  bottom: '0',
  color: theme.brandColorOrange,
  height: '6vh',
  width: '100%',
  backgroundColor: theme.footerBg,
  textAlign: 'center',
  fontSize: '0.8125rem',
  '@media print': {
    display: 'none !important',
  },
}))

export const FooterContent = styled('span')({
  color: theme.footerSpanColor,
  fontSize: '0.8125rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const Typography = styled('span')(
  ({ color, size, bold, variant, regular }) => ({
    color,
    fontSize: size,
    // eslint-disable-next-line no-nested-ternary
    fontFamily: regular
      ? 'PoppinsRegular'
      : bold
        ? 'PoppinsSemiBold'
        : 'PoppinsMedium',
    textDecoration: 'none',
    textTransform: variant || 'none',
  }),
)

export const GradientBackground = styled('div')(({ background }) => ({
  background,
}))

export const PreInterviewWrapper = styled('div')(({ background }) => ({
  background,
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  overflow: 'auto',
  position: 'relative',
}))

export const PreInterviewInnerWrapper = styled('div')(() => ({
  height: '90%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  overflow: 'auto',
  padding: '20px 0',
  position: 'relative',
}))

export const LogoWrapper = styled(Row)(() => ({
  position: 'sticky',
  top: '0',
  left: '0',
}))

export const GradientInterviewBackground = styled('div')(({ background }) => ({
  background,
  height: '100vh',
  overflow: 'hidden',
  position: 'relative',
}))

export const JobApplicationPositionCard = styled('div')(() => ({
  backgroundColor: theme.white,
  borderRadius: '8px',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
  border: '1px solid #E5EAEF',
}))

export const NotificationMessagePageBox = styled('div')(({ color }) => ({
  backgroundColor: theme.white,
  border: `5px solid ${color}`,
  color,
  minWidth: '30%',
}))

export const ExternalLink = styled('a')(({ color, variant, decoration }) => ({
  color,
  textDecoration: decoration || 'none',
  textTransform: variant || 'none',
  '&:hover': {
    color,
    textDecoration: 'none',
    textTransform: variant || 'none',
  },
}))

export const Clock = styled('div')(() => ({
  padding: '24px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flexGrow: '1 !important',
  borderTop: `3px solid ${theme.headersMiniTitle}`,
  '& h1': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '0',
  },
  '& h2': {
    color: theme.darkBlue,
  },
}))

export const CardHeader = styled('h2')(() => ({
  // backgroundColor: theme.headersMiniTitle,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  opacity: 0.8,
  color: theme.hintsNotifications,
  paddingTop: '5px',
  fontSize: '16px',
  fontWeight: '600',
  minHeight: '80px',
  // borderRadius: '12px 12px 0 0',
  textTransform: 'capitalize',
}))

export const FormTitleContainer = styled('div')(() => ({
  position: 'sticky',
  top: 0,
  zIndex: 30,
}))

export const FormCardRibbon = styled('div')(() => ({
  backgroundColor: theme.brandColorOrange,
  color: theme.white,
  padding: '5px',
  fontSize: '25px',
  borderRadius: '10px 10px 0 0',
  textTransform: 'capitalize',
}))

export const FormCard = styled('div')(() => ({
  width: '100%',
  color: theme.headersMiniTitle,
  background: '#FFFFFF 0% 0% no-repeat padding-box',
  borderRadius: '10px 10px 0 0',
}))

export const FormCardHeaderSpecific = styled('span')(() => ({
  color: theme.brandColorOrange,
}))

export const FormCardHeader = styled('h1')(() => ({
  padding: '20px',
  fontSize: '30px',
  fontWeight: 'bold',
  textTransform: 'capitalize',
}))

export const CustomCard = styled('div')(() => ({
  borderColor: 'transparent !important',
  backgroundColor: theme.white,
  padding: '10px !important',
  boxShadow: '0px 10px 20px 0px rgba(18, 38, 63, 0.03) !important',
  height: 'calc(80vh - 300px - 16px)',
  overflowY: 'auto',
  overflowX: 'hidden',
}))

export const FlexCard = styled('div')(() => ({
  borderColor: 'transparent !important',
  backgroundColor: theme.white,
  padding: '10px !important',
  boxShadow: '0px 10px 20px 0px rgba(18, 38, 63, 0.03) !important',
  height: '300px',
}))

export const CalendarCard = styled(Card)(({ height }) => ({
  borderColor: 'transparent !important',
  backgroundColor: theme.white,
  padding: '10px !important',
  boxShadow: '0px 10px 20px 0px rgba(18, 38, 63, 0.03) !important',
  height: height || 'auto',
  borderRadius: '0px',
  overflowX: 'hidden',
  border: 'none',
}))

export const Title = styled('h1')(() => ({
  textAlign: 'center',
  fontSize: '22px',
  color: theme.headersMiniTitle,
  fontWeight: 700,
  textTransform: 'capitalize',
}))

export const RootContainer = styled('div')(() => ({
  height: '100vh',
  width: '100%',
}))

export const FixedRootContainer = styled('div')(() => ({
  // height: 'auto',
  width: '100vw',
}))

export const PageContainer = styled('div')(() => ({
  background:
    'transparent linear-gradient(0deg, #3927514D 0%, #80808000 100%) 0% 0% no-repeat padding-box',
  height: '90%',
  width: '100%',
  paddingBottom: '50px',
  overflow: 'auto',
}))

export const InnerPageContent = styled('div')(() => ({
  color: theme.headersMiniTitle,
  height: '100%',
  width: '100%',
}))

export const NoMarginRow = styled(Row)(() => ({
  width: '100%',
  height: '100%',
}))

export const MarginRow = styled(Row)(() => ({
  margin: '0 30px',
}))

export const LeftCol = styled(Col)(() => ({
  width: '22.3vw',
  marginTop: '20px',
  padding: '0 61px',
  fontWeight: 'bold',
}))

export const MiddleCol = styled(Col)(() => ({
  width: '55.2vw',
  margin: 'auto',
}))

export const VideoContainer = styled('div')(() => ({
  width: '44.5vw',
  height: '49.2vh',
  backgroundColor: '#BFBEBA',
  shadowBox: '0px 3px 6px #12263F33',
  borderRadius: '5px',
  textAlign: 'center',
  position: 'relative',
}))

export const RecordStatusText = styled('div')(() => ({
  textAlign: 'center',
  marginTop: '10px',
}))

export const CenterDiv = styled('div')(() => ({
  textAlign: 'center',
}))

export const RightDiv = styled('div')(() => ({
  textAlign: 'right',
}))

export const RightCol = styled(Col)(() => ({
  width: '19vw',
  // paddingLeft: '20px',
  marginTop: '20px',
  padding: '0 30px',
}))

export const CustomTransparentButton = styled(Button)(() => ({
  background: 'transparent !important',
  color: `${theme.headersMiniTitle} !important`,
  border: `0.063rem solid ${theme.brandColorOrange} !important`,
  borderRadius: '7px',
  boxShadow: 'none !important',
  margin: '0.45rem 0',
}))

export const PreInterviewCarousel = styled(Carousel)`
  min-height: '80vh';
  > .carousel-inner .carousel-item {
    width: 100%;
    height: 100%;
    border-radius: 0;
    img {
      object-fit: cover;
    }
  }
  > .carousel-control-prev,
  > .carousel-control-next {
    background-color: #3c3a55;
    color: #ffffff;
    font-size: 20px;
    border: none;
    outline: none;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    top: 50%;
    &:hover {
      background-color: #343a40;
      color: #ffffff;
    }
  }
`

export const PreInterviewCarouselCaption = styled(Carousel.Caption)(() => ({
  color: 'black',
  position: 'relative',
  left: 'auto',
  right: 'auto',
  bottom: 'auto',
}))

// new design styles

export const OverlayDiv = styled('div')(() => ({
  position: 'fixed',
  zIndex: 1000,
  backgroundColor: theme.talentinoBlack,
  boxShadow: '0px 15px 20px 0px rgba(18, 38, 63, 0.15)',
  opacity: '0.3',
  width: '100vw',
  height: '100vh',
  top: 0,
  left: 0,
}))

export const PreInterviewInstructionImg = styled('img')(() => ({
  display: 'block',
  height: 'auto',
  maxHeight: '450px',
}))

export const CalendarPickerContainer = styled('div')(() => ({
  position: 'fixed',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: '9999',
  backgroundColor: theme.white,
  borderRadius: '16px',
  boxShadow: '0px 20px 60px rgba(0, 0, 0, 0.22)',
  padding: '0',
  width: '400px',
  maxWidth: '95vw',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  '&::-webkit-scrollbar': { width: '6px' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ccc',
    borderRadius: '10px',
  },
  '@media (max-height: 700px)': {
    top: '20px',
    transform: 'translateX(-50%)',
    marginBottom: '20px',
  },
  maxHeight: '95vh',
}))

export const MainContainer = styled('div')(
  {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  (props) => ({
    backgroundColor: props.backgroundColor || theme.mainContentBg,
    justifyContent: props.centered ? 'center' : undefined,
    alignItems: props.centered ? 'center' : undefined,
    paddingBottom: props.centered ? '50px' : undefined,
  }),
)

export const CompanyDetailsDetailsRow = styled('tr')({
  borderTop: '15px solid transparent',
})

export const CompanyDetailsDetailsCell = styled('td')({
  display: 'flex',
  alignItems: 'start',
  fontSize: '16px',
  fontWeight: '600',
  color: theme.hintsNotifications,
  width: '218.109px',
})

export const CompanyDetailsDetailsContent = styled('td')({
  fontSize: '14px',
  fontWeight: '500',
  color: theme.talentinoDarkerGray,
})

export const JobDetailsDetailsWrapper = styled('div')({
  padding: '3px',
})

export const JobDetailsDetailsSection = styled('div')(({ borderTop }) => ({
  borderTop: `${borderTop} 24px solid transparent`,
}))

export const JobDetailsDetailsHeader = styled('h3')({
  display: 'flex',
  alignItems: 'start',
  fontSize: '16px',
  fontWeight: 600,
  color: theme.hintsNotifications,
  width: '218.109px',
})

export const JobDetailsDetailsContent = styled('p')({
  fontSize: '14px',
  fontWeight: 500,
  color: theme.talentinoDarkerGray,
})

export const CalendarTimeBox = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '16px 0',
  backgroundColor: theme.talentinoOfWhite,
  width: 'fit-content',
  padding: '16px',
  gap: '16px',
  borderRadius: '8px',
})

export const ImageContainer = styled('div')({
  width: '100%',
})

export const StyledContainer = styled(Container)({
  display: 'flex',
  marginTop: '30px ',
})

export const StyledRow = styled(Row)({
  display: 'flex',
  width: '100%',
  gap: '10px',
})

export const CalendarPageWrapper = styled('div')({
  backgroundColor: '#F1F5FA',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
})

export const CalendarHeaderRow = styled(Row)({
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backgroundColor: theme.white,
  padding: '0px 20px',
})

export const CalendarPageContent = styled('div')({
  padding: '24px 80px 32px',
  flex: 1,
  '@media (max-width: 768px)': {
    padding: '20px 20px 20px',
  },
})

export const StyledCol = styled(Col)({
  // height: '100%',
  padding: '0',
  flexGrow: 1,
  position: 'relative',
})

export const StyledColFlex = styled(Col)({
  display: 'flex',
  flexDirection: 'column',
  // justifyContent: 'center',
  gap: '10px',
  justifySelf: 'stretch',
  height: '100%',
})

export const CalendarLogoContainer = styled('div')({
  position: 'absolute',
  top: 15,
  zIndex: 10,
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
})

export const LogoImage = styled('img')({
  backgroundColor: theme.talentinoOfWhite,
  padding: '2px',
  zIndex: 10,
})

export const StyledRowAuto = styled('div')({
  marginTop: '10px',
  height: 'auto',
  overflow: 'auto',
})

export const InstructionsContainer = styled('div')({
  background: theme.white,
  width: 'calc(100% - 40px)',
  display: 'flex',
  height: '62px',
  padding: '16px 24px',
  margin: '0 20px',
})

export const InstructionsText = styled('p')({
  color: theme.hintsNotifications,
  fontSize: '18px',
  fontWeight: '600',
})

export const StepsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'start',
  marginTop: '10px',
  marginLeft: '40px',
})

export const StepsText = styled('p')({
  color: theme.talentinoDarkerGray,
  fontSize: '14px',
  fontWeight: '400',
  width: '400px',
})

export const CarouselButton = styled('button')(
  {
    width: '14px',
    height: '5px',
    borderRadius: '8px',
    border: 'none',
  },
  (props) => ({
    backgroundColor: props.selected
      ? theme.talentinoBlue
      : theme.talentinoSkyBlue,
  }),
)

export const BackButton = styled('button')(
  {
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 16px',
    height: '36px',
    width: '150px',
    borderRadius: '2px',
    background: 'transparent',
    border: 'none',
    color: theme.hintsNotifications,
    fontSize: '12px',
    fontWeight: '500',
  },
  (props) => ({
    display: props.carouselSelected === 1 ? 'none' : 'flex',
  }),
)

export const ContentContainer = styled('div')(
  ({ width, marginTop, justifyContent, padding }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: justifyContent || 'center',
    alignItems: 'center',
    width: width || '100%',
    height: '100%',
    padding: padding || '30px',
    flexGrow: 1,
    marginTop: marginTop || 'auto',
  }),
)

export const CarouselContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
})

export const CarouselTitle = styled('h2')({
  color: theme.hintsNotifications,
  fontSize: '18px',
  fontWeight: '600',
  marginTop: '10px',
})

export const CarouselText = styled('p')({
  color: theme.talentinoDarkerGray,
  fontSize: '14px',
  fontWeight: '400',
  marginTop: '10px',
})

export const ButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '2px',
  marginTop: '10px',
})

export const FooterContainer = styled('div')(({ isMobile }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  justifyContent: 'end',
  alignItems: 'center',
  width: '100%',
  gap: isMobile ? '8px' : '10px',
  marginTop: 'auto',
}))

export const StyledHeading = styled('h2')({
  color: theme.talentinoSpecialBlue,
  fontSize: '18px',
  fontWeight: '600',
  marginTop: '24px',
  textAlign: 'center',
})

export const StyledParagraph = styled('p')(({ color }) => ({
  color: color || theme.hintsNotifications,
  fontSize: '16px',
  fontWeight: '400',
  marginTop: '10px',
  textAlign: 'center',
}))

export const InterviewVideoPreviewContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#000000',
  borderRadius: '8px',
  marginBottom: '10px',
  width: '100%',
})

export const InterviewButtonsContainer = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '16px',
  gap: '25px',
  backgroundColor: theme.white,
  borderRadius: '0 0 7px 7px',
})

export const InterviewQuestionsContainerBox = styled('div')({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'center',
  marginTop: '25px',
  gap: '10px',
})

export const InterviewQuestionTag = styled('p')({
  width: '100%',
  color: theme.hintsNotifications,
  fontSize: '16px',
  fontWeight: '400',
  textTransform: 'capitalize',
  textAlign: 'start',
})

export const InterviewQuestionsTextContainer = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'start',
  gap: '10px',
})

export const InterviewQuestionText = styled('p')({
  fontSize: '18px',
  fontWeight: '600',
})

export const InterviewTimerBox = styled('div')(({ isMobile }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'stretch',
  gap: '6px',
  backgroundColor: theme.talentinoOfWhite,
  padding: isMobile ? '10px' : '16px',
}))

export const InterviewTimerText = styled('h2')(({ isMobile }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.talentinoBlue,
  fontSize: isMobile ? '14px' : '16px',
  fontWeight: '600',
  textTransform: 'capitalize',
  gap: '6px',
  marginBottom: '0px',
}))

export const QuestionsProgressCard = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '12px',
  marginBottom: '16px',
  backgroundColor: theme.white,
})

export const QuestionsProgressContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  gap: '6px',
  padding: '16px',
})

export const Separator = styled('div')(({ margin }) => ({
  border: '1px solid #CED4DA',
  margin: margin || '10px 0',
  width: '100%',
}))

export const QuestionsProgressTitleContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  gap: '11px',
})

export const QuestionsProgressTitle = styled('h2')({
  color: theme.hintsNotifications,
  fontSize: '14px',
  fontWeight: '600',
})

export const PreInterviewCountDownTitle = styled('h2')({
  color: theme.hintsNotifications,
  fontSize: '22px',
  fontWeight: '600',
  marginBottom: '24px',
})

export const QuestionsProgressText = styled('h2')({
  color: theme.hintsNotifications,
  fontSize: '12px',
  fontWeight: '500',
  textTransform: 'capitalize',
})

export const CountdownCard = styled('div')(({ isMobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: isMobile ? '80px' : '150px',
  height: isMobile ? '80px' : '150px',
  padding: isMobile ? '8px' : '16px',
  gap: isMobile ? '6px' : '12px',
  borderRadius: '4px',
  borderTop: '2px solid #BBCCD8',
  background: theme.talentinoOfWhite,
}))

export const CountdownCardHeader = styled('p')(({ isMobile }) => ({
  color: theme.talentinoDarkerGray,
  fontSize: isMobile ? '12px' : '16px',
  fontWeight: '500',
  margin: 0,
}))

export const CountdownCardBody = styled('p')(({ isMobile }) => ({
  color: theme.talentinoSpecialBlue,
  fontSize: isMobile ? '16px' : '22px',
  fontWeight: '600',
  margin: 0,
}))

export const CountDownBoxWrapper = styled('div')(({ isMobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.white,
  padding: isMobile ? '20px 15px' : '40px',
  borderRadius: '8px',
  boxShadow: '0px 15px 20px 0px rgba(18, 38, 63, 0.15)',
  width: isMobile ? '100%' : 'auto',
  maxWidth: isMobile ? '100%' : 'auto',
}))

export const NotificationBox = styled('div')(({ color, minWidth }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.white,
  padding: '40px',
  borderRadius: '8px',
  boxShadow: '0px 15px 20px 0px rgba(18, 38, 63, 0.15)',
  minWidth: minWidth || '465px',
  '& p': {
    color,
    fontSize: '20px',
    fontWeight: '600',
    marginTop: '24px',
  },
}))

export const CareerNoVacanciesContainer = styled('div')(() => ({
  textAlign: 'center',
  marginTop: '2rem',
}))

export const CareerNoVacanciesMessage = styled('div')(({ fontSize }) => ({
  fontSize: fontSize || '1.5rem',
  margin: '1rem 0',
}))

export const CareerContainer = styled('div')(() => ({
  width: '340px',
  height: '200px',
  padding: 14,
  background: 'white',
  boxShadow: '0px 10px 20px rgba(18, 38, 63, 0.03)',
  borderRadius: 6,
  borderTop: '2px #076698 solid',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-end',
  gap: 8,
}))

export const CareerStretch = styled('div')(() => ({
  alignSelf: 'stretch',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  display: 'flex',
  gap: 8,
}))

export const CareerColumn = styled('div')(() => ({
  flex: '1 1 0',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 4,
}))

export const CareerText = styled('div')(({ color, fontSize, fontWeight }) => ({
  color: color || '#5A5555',
  fontSize: fontSize || 10,
  fontFamily: 'Poppins',
  fontWeight: fontWeight || 400,
  wordWrap: 'break-word',
}))

export const CareerLocation = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 8,
}))

export const CareerDot = styled('div')(() => ({
  width: 4,
  height: 4,
  background: '#C9D6E1',
  borderRadius: '50%',
}))

export const CareerFooter = styled('div')(() => ({
  width: 303,
  padding: '0 10px',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 18,
  marginTop: 'auto',
}))

export const CareerLine = styled('div')(() => ({
  width: 298,
  height: 0,
  border: '1px #C8C9CA solid',
}))

export const CareerLinkContainer = styled('div')(() => ({
  alignSelf: 'stretch',
  height: 16,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const CareerLink = styled('div')(() => ({
  color: '#137FC3',
  fontSize: 14,
  fontFamily: 'Poppins',
  fontWeight: 600,
  textDecoration: 'underline',
  textTransform: 'capitalize',
}))

export const CareerPageResponsiveContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
  background: theme.mainContentBg,
  height: '670px',
  flexWrap: 'wrap',

  '& > *': {
    flex: '1 1 100%',
  },

  '@media (min-width: 768px)': {
    '& > *': {
      flex: 1,
    },
  },
}))

export const CareerPageLocationContainer = styled('div')(() => ({
  alignSelf: 'center',
  display: 'flex',
  maxWidth: '100%',
  alignItems: 'center',
  gap: '8px',
  fontSize: '14px',
  fontWeight: 400,
  justifyContent: 'flex-start',
}))

export const CareerPageLocationInfoBlock = styled('div')(() => ({
  alignSelf: 'flex-start',
  display: 'flex',
  marginTop: '4px',
  alignItems: 'center',
  gap: '8px',
  fontSize: '12px',
  color: '#898384',
  justifyContent: 'flex-start',
}))

export const CareerPageJobCard = styled('div')(({ isHighlighted }) => ({
  alignItems: 'center',
  borderRadius: '4px',
  background: isHighlighted ? '#EEF2F5' : '#FFF',
  boxShadow: '0px 10px 20px 0px rgba(18, 38, 63, 0.03)',
  display: 'flex',
  marginTop: '16px',
  width: '100%',
  gap: '8px',
  fontWeight: 400,
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  padding: '16px',
  cursor: 'pointer',
}))

export const CareerPageLogo = styled('img')(({ hasWideAspect }) => ({
  aspectRatio: hasWideAspect ? '2.08' : '1',
  objectFit: 'contain',
  objectPosition: 'center',
  width: '50px',
  borderRadius: '50%',
  alignSelf: 'stretch',
  margin: 'auto 0',
}))

export const CareerPagePlaceholderLogo = styled('span')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.headersMiniTitle,
  aspectRatio: 1,
  objectFit: 'contain',
  objectPosition: 'center',
  width: '50px',
  borderRadius: '50%',
  alignSelf: 'stretch',
  margin: 'auto 0',
  fontWeight: 'bold',
  color: 'white',
}))

export const CareerPageDetails = styled('div')(() => ({
  alignSelf: 'stretch',
  display: 'flex',
  minWidth: '240px',
  flexDirection: 'column',
  justifyContent: 'flexStart',
  width: '263px',
  margin: 'auto 0',
}))

export const CareerPageCompanyName = styled('h2')(() => ({
  color: '#726c6c',
  fontSize: '14px',
  fontWeight: 400,
  margin: 0,
}))

export const CareerPageJobTitle = styled('h3')(() => ({
  color: '#151314',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: 1.6,
  textTransform: 'capitalize',
  marginTop: '4px',
  margin: 0,
}))

export const CareerPageMetaInfo = styled('div')(() => ({
  alignSelf: 'flex-start',
  display: 'flex',
  marginTop: '4px',
  alignItems: 'center',
  gap: '8px',
  fontSize: '12px',
  color: '#898384',
  justifyContent: 'flex-start',
}))

export const CareerPageSection = styled('section')(() => ({
  borderRadius: '6px',
  background: '#fff',
  boxShadow: '0px 10px 20px 0px rgba(18, 38, 63, 0.03)',
  backgroundColor: '#fff',
  display: 'flex',
  marginTop: '24px',
  height: '323px',
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  padding: '25px 20px 0',
  overflow: 'auto',
}))

export const CareerPageTitle = styled('h3')(() => ({
  color: '#5a5555',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: 1.6,
  textTransform: 'capitalize',
  margin: 0,
}))

export const CareerPageDivider = styled('hr')(() => ({
  minHeight: '0px',
  marginTop: '16px',
  width: '100%',
  border: '1px solid rgba(200, 201, 202, 1)',
}))

export const CareerPageDescription = styled('div')(() => ({
  color: '#7a858c',
  fontSize: '12px',
  fontWeight: 400,
  marginTop: '16px',
  paddingLeft: '20px',
}))

export const CareerPageJobHeaderSection = styled('section')(({ height }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '6px',
  background: '#fff',
  boxShadow: '0px 10px 20px 0px rgba(18, 38, 63, 0.03)',
  display: 'flex',
  height: height || '323px',
  width: '100%',
  gap: '8px',
  padding: '26px 16px',
}))

export const CareerPageArticle = styled('div')(() => ({
  alignSelf: 'stretch',
  display: 'flex',
  minWidth: '240px',
  width: '424px',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto 0',
}))

export const CareerPageHeader = styled('header')(() => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#726c6c',
  justifyContent: 'center',
}))

export const CareerPageLogoWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}))

export const CareerPageLogoImage = styled('img')(() => ({
  aspectRatio: 1,
  objectFit: 'contain',
  objectPosition: 'center',
  width: '100px',
  borderRadius: '50%',
  maxWidth: '100%',
}))

export const CareerPageJobHeaderPlaceholderLogo = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.headersMiniTitle,
  color: theme.gray100,
  fontSize: '26px',
  fontWeight: 600,
  aspectRatio: 1,
  objectFit: 'contain',
  objectPosition: 'center',
  width: '100px',
  borderRadius: '50%',
  alignSelf: 'stretch',
  margin: 'auto 0',
}))

export const CareerPageJobHeaderDetails = styled('div')(() => ({
  display: 'flex',
  marginTop: '8px',
  width: '100%',
  maxWidth: '411px',
  flexDirection: 'column',
  justifyContent: 'center',
}))

export const CareerPageJobHeaderCompanyName = styled('h2')(() => ({
  textAlign: 'center',
  fontSize: '16px',
  fontWeight: 500,
  margin: 0,
}))

export const CareerPageJobHeaderTitle = styled('h1')(() => ({
  width: '100%',
  color: '#2b2829',
  textAlign: 'center',
  fontSize: '1.2rem',
  fontWeight: 600,
  paddingTop: '8px',
  paddingBottom: '8px',
  margin: 0,
}))

export const CareerPageButtonWrapper = styled('div')(() => ({
  alignSelf: 'center',
  display: 'flex',
  marginTop: '16px',
  width: '100%',
  maxWidth: '424px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const CareerPageContainer = styled('main')(() => ({
  borderRadius: '6px',
  backgroundColor: 'rgba(255, 255, 255, 1)',
  position: 'relative',
  display: 'flex',
  minWidth: '240px',
  flexDirection: 'column',
  justifyContent: 'start',
  flexGrow: 1,
  width: '100%',
  height: '670px',
  overflow: 'scroll',
  padding: '16px 16px 0',
}))

export const VoiceOverButton = styled('button')(() => ({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  backgroundColor: theme.talentinoBlue,
  border: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.2s ease',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: theme.talentinoDarkerBlue,
    transform: 'scale(1.05)',
  },
  '&:active': {
    transform: 'scale(0.95)',
  },
  '& svg': {
    display: 'block',
    margin: '0 auto',
    verticalAlign: 'middle',
  },
}))

export const CareerPageList = styled('section')(() => ({
  marginTop: '16px',
}))

export const CareerPageJobCardContainer = styled('main')(() => ({
  display: 'flex',
  minWidth: '240px',
  flexDirection: 'column',
  justifyContent: 'start',
  flexGrow: 1,
  width: '100%',
}))

export const DeviceControlMainContainer = styled('div')(({ isMobile }) => ({
  maxWidth: isMobile ? '100%' : '56rem',
  margin: '0 auto',
  marginTop: 'calc(1.5rem * calc(1 - 0))',
  marginBottom: 'calc(1.5rem * 0)',
}))

export const DeviceControlRecordingAreaContainer = styled('div')(() => ({
  position: 'relative',
  background: 'linear-gradient(to bottom right, #ebf8ff, #eef2ff)',
  borderRadius: '0.5rem 0.5rem 0 0',
  overflow: 'visible',
  boxShadow:
    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05), (239, 246, 255, 0))',
}))

export const DeviceControlAlertBox = styled('div')(({ isMobile }) => ({
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  right: '1rem',
  zIndex: 110,
  backgroundColor: theme.talentinoRed,
  border: `1px solid ${theme.talentinoDarkerRed}`,
  borderRadius: '0.5rem',
  color: '#ffffff',
  padding: isMobile ? '0.5rem 0.75rem' : '0.75rem 0.875rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  boxShadow: '0 4px 12px rgba(169, 60, 56, 0.2)',
  fontSize: isMobile ? '12px' : '14px',
  '&:hover': {
    backgroundColor: theme.talentinoDarkerRed,
    boxShadow: '0 4px 16px rgba(169, 60, 56, 0.3)',
  },
}))

export const DeviceControlVideoContainer = styled('div')(({ isMobile }) => ({
  position: 'relative',
  aspectRatio: '16 / 9',
  backgroundColor: '#1f2937',
  minHeight: isMobile ? '180px' : 'auto',
}))

export const DeviceControlVideoElement = styled('video')(({ isMobile }) => ({
  width: '100%',
  minWidth: isMobile ? 'auto' : '640px',
  height: '100%',
  objectFit: 'contain',
  backgroundColor: '#000',
}))

export const DeviceControlVideoElementCover = styled('video')(
  ({ isMobile }) => ({
    width: '100%',
    minWidth: isMobile ? 'auto' : '640px',
    height: '100%',
    objectFit: 'cover',
  }),
)

export const DeviceControlCenteredFlexContainer = styled('div')(
  ({ isMobile }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minWidth: isMobile ? 'auto' : '640px',
    color: '#ffffff',
    gap: '1rem',
  }),
)

export const DeviceControlParagraph = styled('p')(() => ({
  color: '#9ca3af',
  fontSize: '1.125rem',
}))

export const DeviceControlFloatingControls = styled('div')(() => ({
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  display: 'flex',
  gap: '0.5rem',
}))

export const DeviceControlBadge = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  backgroundColor: theme.talentinoOfWhite,
  padding: '0.375rem 0.75rem',
  borderRadius: '12px',
  fontSize: '0.875rem',
}))

export const DeviceControlSettingsButton = styled(Button)(() => ({
  color: '#4B5563',
  display: 'flex',
  alignItems: 'center',
  gap: '0.2rem',
  backgroundColor: theme.talentinoOfWhite,
  padding: '0.375rem 0.75rem',
  borderRadius: '12px',
  fontSize: '0.7rem',
  transition: 'background-color 0.2s ease-in-out',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: '#ffffff',
    color: '#4B5563',
  },
  '&:active': {
    backgroundColor: 'rgba(255, 255, 255, 0.8) !important',
    color: '#4B5563 !important',
  },
}))

export const DeviceControlDropdownMenu = styled('div')(() => ({
  position: 'absolute',
  top: '100%',
  left: 0,
  marginTop: '0.5rem',
  width: '20rem',
  backgroundColor: '#ffffff',
  borderRadius: '0.75rem',
  boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)',
  padding: '1rem',
  zIndex: 10,
}))

export const DeviceControlCard = styled('div')(() => ({
  backgroundColor: '#ffffff',
  borderRadius: '0 0 0.5rem 0.5rem',
  boxShadow: '0 10px 15px rgba(0, 0, 0, 0.1)',
  padding: '0.5rem',
}))

export const DeviceControlOutlineControlBar = styled('div')(() => ({
  display: 'flex',
  gap: '10px',
  backgroundColor: theme.white,
  borderRadius: '12px',
  boxShadow: '0 1px 3px rgba(19, 127, 195, 0.03)',
}))

export const DeviceControlOutlineButton = styled('button')(({ isEnabled }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '42px',
  height: '42px',
  borderRadius: '10px',
  border: `1px solid ${
    isEnabled ? theme.talentinoDisabledBlue : theme.talentinoWhiteBlue
  }`,
  background: isEnabled ? theme.talentinoOfWhite : '#ffffff',
  color: isEnabled ? theme.talentinoSpecialBlue : theme.talentinoDarkerGray,
  cursor: 'pointer',
  transition: 'all 0.25s ease',

  '&:hover': {
    border: `1px solid ${theme.talentinoDisabledBlue}`,
    background: theme.talentinoOfWhite,
  },

  '& svg': {
    width: '17px',
    height: '17px',
  },
}))

export const DeviceSettingsDropdownContainer = styled('div')(() => ({
  position: 'relative',
  display: 'inline-block',
}))

export const DeviceSettingsDropdownContent = styled('div')(
  ({ isOpen, isMobile }) => ({
    position: 'absolute',
    top: '100%',
    left: 0,
    marginTop: '8px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow:
      '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    width: isMobile ? '230px' : '320px',
    opacity: isOpen ? 1 : 0,
    visibility: isOpen ? 'visible' : 'hidden',
    transform: isOpen ? 'translateY(0)' : 'translateY(-10px)',
    transition: 'all 0.2s',
    zIndex: 100,
  }),
)

export const DeviceSettingsSection = styled('div')(() => ({
  padding: '16px',
  borderBottom: '1px solid #e2e8f0',

  '&:last-child': {
    borderBottom: 'none',
  },
}))

export const DeviceSettingsSectionHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '10px',
  color: '#4a5568',
  fontSize: '12px',
}))

export const DeviceSettingsSelect = styled('select')({
  width: '100%',
  padding: '8px 12px',
  border: '1px solid #e2e8f0',
  borderRadius: '6px',
  background: '#f8fafc',
  fontSize: '12px',
  color: '#1a202c',
  cursor: 'pointer',

  '&:focus': {
    outline: 'none',
    borderColor: '#3182ce',
    boxShadow: '0 0 0 1px #3182ce',
  },
})

export const DeviceSettingsAudioLevelContainer = styled('div')(() => ({
  marginTop: '12px',
}))

export const DeviceSettingsAudioLevelBar = styled('div')(({ level }) => ({
  height: '4px',
  background: '#e2e8f0',
  borderRadius: '2px',
  overflow: 'hidden',

  '&::after': {
    content: '""',
    display: 'block',
    height: '100%',
    width: `${level}%`,
    background: '#3182ce',
    transition: 'width 0.1s ease-out',
  },
}))

export const FullPageContainer = styled('div')(() => ({
  width: '100vw',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.talentinoSkyBlue,
}))

export const ScrollableContainer = styled(Container)(() => ({
  flexGrow: 1,
  overflowY: 'auto',
  paddingBottom: '80px',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}))

export const StickyFooter = styled('div')(() => ({
  position: 'sticky',
  bottom: 0,
  left: 0,
  right: 0,
  marginLeft: '30px',
  marginBottom: '30px',
  display: 'inline-flex',
  padding: '15px',
  backgroundColor: 'transparent',
  zIndex: 10,
}))

export const FooterText = styled('p')(() => ({
  color: theme.talentinoDarkerGray,
  fontSize: '13px',
  fontWeight: '400',
  margin: 0,
}))

export const InfoCard = styled(Card)(() => ({
  borderRadius: '20px',
  border: `1px solid ${theme.talentinoWhiteBlue}`,
  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.06)',
}))

export const PillBadge = styled(Card)(() => ({
  borderRadius: '20px',
  backgroundColor: theme.talentinoLightBlueBackground,
  border: `1px solid ${theme.talentinoBlue}`,
  color: theme.talentinoBlue,
}))

export const AgencyBannerContainer = styled('div')(() => ({
  backgroundColor: theme.talentinoSkyBlue,
  borderRadius: '10px',
  padding: '16px 20px',
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  border: '1px solid #e0e7ef',
}))

export const AgencyLogoContainer = styled('div')(() => ({
  width: '56px',
  height: '56px',
  minWidth: '56px',
  borderRadius: '50%',
  overflow: 'hidden',
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
}))

export const AgencyLogoImage = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
}))

export const AgencyTextContainer = styled('div')(() => ({
  flex: 1,
  minWidth: 0,
}))

export const AgencyLabelContainer = styled('div')(() => ({
  marginBottom: '4px',
}))

export const AgencyNameContainer = styled('div')(() => ({
  marginBottom: '3px',
}))

export const AgencyCard = styled(Card)(() => ({
  borderRadius: '12px',
  border: `1px solid ${theme.talentinoWhiteBlue}`,
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
  backgroundColor: theme.white,
}))

export const HeroBannerSection = styled('div')(() => ({
  background: `linear-gradient(135deg, ${theme.talentinoSpecialBlue} 0%, ${theme.talentinoSpecialDarkBlue} 100%)`,
  borderRadius: '20px',
  padding: '28px 32px',
  position: 'relative',
  overflow: 'hidden',
  '@media (max-width: 576px)': {
    padding: '20px 18px',
    borderRadius: '14px',
  },
}))

export const HeroBannerTitle = styled('h1')(() => ({
  color: '#ffffff',
  fontSize: '26px',
  fontWeight: '700',
  marginBottom: '14px',
  marginTop: '8px',
  lineHeight: '1.2',
  '@media (max-width: 576px)': {
    fontSize: '20px',
    marginBottom: '10px',
  },
}))

export const HeroBannerMetaRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '18px',
  marginBottom: '14px',
}))

export const HeroBannerMetaItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: 'rgba(255,255,255,0.9)',
  fontSize: '13px',
  fontWeight: '400',
}))

export const HeroBannerTagsRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
}))

export const HeroBannerTag = styled('span')(() => ({
  padding: '5px 14px',
  borderRadius: '50px',
  backgroundColor: 'rgba(0,0,0,0.22)',
  border: '1.5px solid rgba(255,255,255,0.25)',
  color: '#ffffff',
  fontSize: '12px',
  fontWeight: '500',
}))

export const HeroBannerActionsCol = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'center',
  gap: '10px',
  minWidth: '196px',
  '@media (max-width: 576px)': {
    width: '100%',
    minWidth: 'unset',
  },
}))

export const HeroBannerApplyButton = styled('button')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '11px 20px',
  backgroundColor: '#ffffff',
  color: theme.talentinoSpecialBlue,
  border: '2px solid #ffffff',
  borderRadius: '50px',
  fontSize: '14px',
  fontWeight: '600',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.9)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
  },
}))

export const HeroBannerSaveButton = styled('button')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '9px 20px',
  backgroundColor: 'transparent',
  color: '#ffffff',
  border: '1.5px solid rgba(255,255,255,0.55)',
  borderRadius: '50px',
  fontSize: '13px',
  fontWeight: '500',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderColor: 'rgba(255,255,255,0.85)',
  },
}))

// Form Components Styled
export const FormGroupContainer = styled(Form.Group)(() => ({
  marginBottom: '0.5rem',
}))

export const FormLabelStyled = styled(Form.Label)(() => ({
  color: '#6c757d',
  margin: 0,
  marginBottom: '0.25rem',
  fontSize: '12px',
}))

export const FormControlStyled = styled(Form.Control)(() => ({
  borderRadius: '6px',
  fontSize: '12px',
  height: '36px',
}))

export const FormTextAreaStyled = styled(Form.Control)(() => ({
  borderRadius: '6px',
  fontSize: '12px',
  minHeight: '80px',
}))

export const FormSelectStyled = styled(Form.Select)(() => ({
  borderRadius: '6px',
  fontSize: '12px',
  height: '36px',
}))

export const FormTextStyled = styled(Form.Text)(({ isError }) => ({
  fontSize: '12px',
  display: 'block',
  marginTop: '4px',
  color: isError ? theme.talentinoRed : '#6c757d',
}))

export const FileInputContainer = styled('div')(() => ({
  position: 'relative',
}))

export const HiddenFileInput = styled('input')(({ disabled }) => ({
  position: 'absolute',
  opacity: 0,
  width: '100%',
  height: '36px',
  cursor: disabled ? 'not-allowed' : 'pointer',
  zIndex: 2,
}))

export const FileInputDisplay = styled('div')(({ disabled }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '36px',
  border: '1px solid #ced4da',
  borderRadius: '6px',
  backgroundColor: 'white',
  overflow: 'hidden',
  pointerEvents: disabled ? 'none' : 'auto',
  cursor: disabled ? 'not-allowed' : 'default',
}))

export const FileInputButton = styled('button')(({ isRTL }) => ({
  height: '36px',
  padding: '0 12px',
  fontSize: '12px',
  border: 'none',
  borderRadius: isRTL ? '0 4px 4px 0' : '4px 0 0 4px',
  backgroundColor: '#e9ecef',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  [isRTL ? 'borderLeft' : 'borderRight']: '1px solid #ced4da',
}))

export const FileInputText = styled('span')(({ hasFile }) => ({
  flex: 1,
  padding: '0 12px',
  fontSize: '12px',
  color: hasFile ? '#212529' : '#6c757d',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const CustomInputWrapper = styled('div')(({ checked }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '10px 15px',
  borderRadius: '8px',
  border: `1px solid ${checked ? theme.brandColorOrange : '#E0E0E0'}`,
  backgroundColor: checked ? `${theme.brandColorOrange}08` : 'white',
  transition: 'all 0.2s ease',
  cursor: 'pointer',
  marginBottom: '8px',
  '&:hover': {
    borderColor: theme.brandColorOrange,
  },
  input: {
    accentColor: theme.brandColorOrange,
    width: '16px',
    height: '16px',
  },
}))

export const CodeEditorWrapper = styled('div')(() => ({
  border: '1px solid #333',
  borderRadius: '8px',
  overflow: 'hidden',
  background: '#1e1e1e', // VS Code style dark theme
  marginTop: '12px',
}))

export const CodeHeader = styled('div')(() => ({
  background: '#2d2d2d',
  padding: '8px 16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '1px solid #3c3c3c',
}))

// ==============noification page
export const PageWrapper = styled('div')(() => ({
  minHeight: '100vh',
  backgroundColor: '#EEF2F7',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'hidden',
}))

export const BgCircles = styled('div')(() => ({
  position: 'absolute',
  top: -60,
  right: -60,
  width: '100%',
  zIndex: 0,
  pointerEvents: 'none',
  opacity: 0.4,
  overflow: 'hidden',
  '@media (min-width: 576px)': {
    top: -150,
    right: -150,
    width: '75%',
  },
  '@media (min-width: 992px)': {
    top: -300,
    right: -300,
  },
}))

export const ContentArea = styled('div')(() => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '1.25rem 1rem',
  position: 'relative',
  zIndex: 1,
  '@media (min-width: 576px)': {
    padding: '2rem',
  },
}))

export const Digit = styled('span')(() => ({
  fontSize: 'clamp(6rem, 18vw, 11rem)',
  fontWeight: 800,
  color: '#076698',
  lineHeight: 1,
}))

export const SearchCircle = styled('div')(() => ({
  width: 'clamp(4.5rem, 20vw, 9rem)',
  height: 'clamp(4.5rem, 20vw, 9rem)',
  borderRadius: '50%',
  backgroundColor: '#ffffff',
  border: '10px solid #E9F1F6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}))

export const PageTitle = styled('h1')(() => ({
  fontSize: 'clamp(1.2rem, 5vw, 2rem)',
  fontWeight: 700,
  color: '#0d1b2a',
  marginBottom: '0.75rem',
}))

export const PageDescription = styled('p')(() => ({
  fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
  color: '#6B7280',
  maxWidth: 'min(420px, 90vw)',
  lineHeight: 1.6,
  margin: 0,
}))

// === JobApplication Page Components ===

export const JobAppPositionCard = styled(JobApplicationPositionCard)(() => ({
  boxShadow: '0px 1px 2px 0px rgba(18, 38, 63, 0.96)',
  overflowY: 'auto',
  maxHeight: '70vh',
}))

export const BannerDecorCircleLarge = styled('div')(() => ({
  position: 'absolute',
  right: '-25px',
  top: '-25px',
  width: '210px',
  height: '210px',
  borderRadius: '50%',
  border: '2px solid rgba(255,255,255,0.07)',
  pointerEvents: 'none',
}))

export const BannerDecorCircleSmall = styled('div')(() => ({
  position: 'absolute',
  right: '45px',
  top: '15px',
  width: '135px',
  height: '135px',
  borderRadius: '50%',
  border: '2px solid rgba(255,255,255,0.05)',
  pointerEvents: 'none',
}))

export const BannerContentLayout = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '20px',
  flexWrap: 'wrap',
  '@media (max-width: 576px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
  },
}))

export const BannerTitleArea = styled('div')(() => ({
  flex: 1,
  minWidth: 0,
}))

export const BannerAgencyRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
}))

export const BannerAgencyText = styled('span')(() => ({
  fontSize: '13px',
  fontFamily: 'PoppinsMedium',
  color: 'rgba(255,255,255,0.85)',
  fontWeight: '500',
}))

export const BlockTypography = styled(Typography)(() => ({
  display: 'block',
}))

export const PositionInfoRow = styled(Row)(() => ({
  marginLeft: '-20px',
  marginRight: '-20px',
}))

export const JobInfoCol = styled(Col)(() => ({
  paddingLeft: '20px',
  paddingRight: '20px',
}))

export const CompanyDetailsCol = styled(Col)(() => ({
  paddingLeft: '20px',
  paddingRight: '20px',
}))

export const PartnerCard = styled('div')(() => ({
  border: `1px solid ${theme.talentinoWhiteBlue}`,
  borderRadius: '12px',
  padding: '16px 20px',
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
}))

export const PartnerCardContent = styled('div')(() => ({
  flex: 1,
  minWidth: 0,
}))

export const PartnerCardLabel = styled('span')(() => ({
  fontSize: '10px',
  fontFamily: 'PoppinsSemiBold',
  color: theme.talentinoBlue,
  textTransform: 'uppercase',
  letterSpacing: '0.7px',
  display: 'block',
  marginBottom: '2px',
}))

export const VerifiedBadge = styled('div')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '5px',
  padding: '5px 12px',
  borderRadius: '50px',
  border: `1.5px solid ${theme.talentinoGreen}`,
  color: theme.talentinoGreen,
  fontSize: '12px',
  fontWeight: '600',
  whiteSpace: 'nowrap',
}))

export const CardSectionHeader = styled('div')(({ mb = '16px' }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  marginBottom: mb,
}))

export const CardIconBox = styled('div')(() => ({
  width: '32px',
  height: '32px',
  backgroundColor: '#F1F5FA',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}))

export const SectionSubLabel = styled('span')(() => ({
  fontSize: '11px',
  fontFamily: 'PoppinsSemiBold',
  color: '#909FBA',
  textTransform: 'uppercase',
  letterSpacing: '0.6px',
  display: 'block',
  marginBottom: '8px',
}))

export const ExperienceSubCard = styled('div')(() => ({
  backgroundColor: theme.talentinoLightBackground,
  borderRadius: '8px',
  padding: '12px 14px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '16px',
  border: `1px solid ${theme.talentinoWhiteBlue}`,
}))

export const ExperienceIconCircle = styled('div')(() => ({
  width: '32px',
  height: '32px',
  minWidth: '32px',
  borderRadius: '50%',
  backgroundColor: theme.talentinoLightBlueBackground,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

export const FieldMicroLabel = styled('span')(() => ({
  fontSize: '10px',
  fontFamily: 'PoppinsSemiBold',
  color: theme.talentinoSecondaryGray,
  textTransform: 'uppercase',
  letterSpacing: '0.6px',
  display: 'block',
}))

export const RequirementsGrid = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  borderRadius: '8px',
  overflow: 'hidden',
}))

export const RequirementsGridCell = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',

  padding: '12px 14px',
  marginRight: '30px',
  borderBottom: `1px solid ${theme.talentinoOfWhite}`,
  backgroundColor: '#fff',
}))

export const RequirementsIconCircle = styled('div')(() => ({
  width: '28px',
  height: '28px',
  minWidth: '28px',
  borderRadius: '50%',
  backgroundColor: '#F1F5FA',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '2px',
}))

export const RequirementsFieldLabel = styled('span')(() => ({
  fontSize: '10px',
  fontFamily: 'PoppinsMedium',
  color: theme.talentinoSecondaryGray,
  letterSpacing: '0.5px',
  display: 'block',
  marginBottom: '2px',
}))

export const SideCard = styled('div')(() => ({
  border: `1px solid ${theme.talentinoWhiteBlue}`,
  borderRadius: '20px',
  padding: '20px',
  backgroundColor: '#fff',
  boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
}))

export const ReadyToJoinText = styled('span')(() => ({
  fontSize: '13px',
  fontFamily: 'PoppinsRegular',
  color: theme.talentinoSecondaryGray,
  display: 'block',
  marginBottom: '4px',
}))

export const ApplyPositionTitle = styled('span')(() => ({
  fontSize: '17px',
  fontFamily: 'PoppinsSemiBold',
  color: theme.talentinoBlack,
  display: 'block',
  marginBottom: '16px',
}))

export const ApplyActionButton = styled('button')(() => ({
  width: '100%',
  padding: '12px',
  backgroundColor: theme.talentinoSpecialBlue,
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: '600',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  marginBottom: '12px',
}))

export const PrivacyRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
}))

export const ProfileCardHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '5px',
}))

export const CompanyLogoImg = styled('img')(() => ({
  width: '44px',
  height: '44px',
  borderRadius: '10px',
  objectFit: 'cover',
}))

export const CompanyDivider = styled('hr')(() => ({
  margin: '0 0 10px 0',
  borderColor: theme.talentinoWhiteBlue,
}))

export const DetailRowsList = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const DetailRow = styled('div')(({ isLast }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '11px',
  paddingBottom: isLast ? 0 : '5px',
  marginBottom: isLast ? 0 : '5px',
  borderBottom: isLast ? 'none' : `1px solid ${theme.talentinoOfWhite}`,
}))

export const DetailIconSlot = styled('span')(() => ({
  width: '28px',
  display: 'flex',
  justifyContent: 'center',
  flexShrink: 0,
}))

export const DetailLabel = styled('span')(() => ({
  fontSize: '13px',
  fontFamily: 'PoppinsRegular',
  color: theme.talentinoSecondaryGray,
  width: '90px',
  flexShrink: 0,
}))

export const ViewProfileButton = styled('button')(() => ({
  width: '100%',
  padding: '10px',
  backgroundColor: 'transparent',
  color: theme.talentinoBlue,
  border: `1.5px solid ${theme.talentinoBlue}`,
  borderRadius: '8px',
  fontSize: '13px',
  fontWeight: '600',
  cursor: 'pointer',
  marginTop: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
}))

export const DetailValueLink = styled(ExternalLink)(() => ({
  fontSize: '13px',
  fontWeight: '600',
}))

export const BoldSpan = styled('span')(() => ({
  fontWeight: '600',
}))

export const ArraySectionWrapper = styled('div')(({ isLast }) => ({
  paddingBottom: isLast ? 0 : '10px',
  marginBottom: isLast ? 0 : '10px',
  borderBottom: isLast ? 'none' : `1px solid ${theme.talentinoOfWhite}`,
}))

export const ArraySectionHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  marginBottom: '10px',
}))

export const ArraySectionTitle = styled('span')(() => ({
  fontSize: '14px',
  fontFamily: 'PoppinsMedium',
  color: theme.talentinoSecondaryGray,
  width: '100px',
}))

export const ArrayCountBadge = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '20px',
  height: '20px',
  padding: '0 6px',
  borderRadius: '50px',
  backgroundColor: theme.talentinoLightBlueBackground,
  color: theme.talentinoBlue,
  fontSize: '12px',
  fontFamily: 'PoppinsSemiBold',
}))

export const ArrayPillsRow = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
}))

export const ArrayPillItem = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '5px 14px',
  borderRadius: '50px',
  border: `1px solid ${theme.talentinoWhiteBlue}`,
  backgroundColor: '#fff',
  color: theme.talentinoBlue,
  fontSize: '10px',
  fontFamily: 'PoppinsMedium',
}))

// ─── TextInstructions ────────────────────────────────────────────────────────

export const TextInstructionsWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '32px 24px',
  width: '100%',
  '@media (max-width: 576px)': {
    padding: '24px 16px',
  },
})

export const TextInstructionsTitle = styled('h1')({
  fontSize: '26px',
  fontWeight: '700',
  color: '#1F2937',
  marginBottom: '10px',
  textAlign: 'center',
  '@media (max-width: 576px)': {
    fontSize: '22px',
  },
})

export const TextInstructionsSubtitle = styled('p')({
  fontSize: '14px',
  color: '#6B7280',
  textAlign: 'center',
  maxWidth: '520px',
  marginBottom: '28px',
  lineHeight: '1.6',
  '@media (max-width: 576px)': {
    fontSize: '13px',
    marginBottom: '20px',
  },
})

export const TextInstructionsSubtitleBold = styled('strong')({
  color: '#1F2937',
})

export const TextInstructionsStepsGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '12px',
  width: '100%',
  maxWidth: '620px',
  marginBottom: '20px',
  '@media (max-width: 576px)': {
    gridTemplateColumns: '1fr',
  },
})

export const TextInstructionsStepCard = styled('div')({
  background: theme.white,
  borderRadius: '12px',
  padding: '16px',
  border: '1px solid #E5E7EB',
})

export const TextInstructionsStepCardHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '8px',
})

export const TextInstructionsStepNumber = styled('span')({
  fontSize: '11px',
  fontWeight: '700',
  color: theme.talentinoBlue,
})

export const TextInstructionsStepTitle = styled('span')({
  fontSize: '13px',
  fontWeight: '600',
  color: '#1F2937',
})

export const TextInstructionsStepDescription = styled('p')({
  fontSize: '12px',
  color: '#6B7280',
  margin: 0,
  lineHeight: '1.6',
})

export const TextInstructionsConnectionCard = styled('div')({
  background: 'linear-gradient(135deg, #0F4C6D 0%, #1068A0 100%)',
  borderRadius: '16px',
  padding: '24px 28px',
  width: '100%',
  maxWidth: '620px',
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  marginBottom: '28px',
  position: 'relative',
  overflow: 'hidden',
})

export const TextInstructionsWifiIconCircle = styled('div')({
  width: '56px',
  height: '56px',
  borderRadius: '50%',
  backgroundColor: 'rgba(255,255,255,0.15)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
})

export const TextInstructionsConnectionCardBody = styled('div')({
  zIndex: 1,
})

export const TextInstructionsConnectionCardTitle = styled('h3')({
  color: theme.white,
  fontSize: '16px',
  fontWeight: '600',
  marginBottom: '6px',
})

export const TextInstructionsConnectionCardText = styled('p')({
  color: 'rgba(255,255,255,0.75)',
  fontSize: '13px',
  marginBottom: '12px',
  lineHeight: '1.5',
})

export const TextInstructionsSpeedBadge = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  backgroundColor: 'rgba(255,255,255,0.18)',
  borderRadius: '20px',
  padding: '5px 14px',
})

export const TextInstructionsSpeedBadgeText = styled('span')({
  color: theme.white,
  fontSize: '12px',
  fontWeight: '500',
})

export const TextInstructionsPrivacyFooter = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  marginTop: '14px',
  color: '#9CA3AF',
  fontSize: '12px',
})

// ─── PreFormInterview ─────────────────────────────────────────────────────────

export const PreFormPageContainer = styled('div')({
  backgroundColor: '#F1F5FA',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
})

export const PreFormNavbar = styled(Row)({
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backgroundColor: theme.white,
  padding: '0px 20px',
})

export const PreFormPageFooter = styled('div')({
  marginTop: 'auto',
  textAlign: 'center',
  padding: '12px 0',
  fontSize: '13px',
  color: theme.talentinoDarkerGray,
})

export const FormImportantCard = styled('div')({
  background: '#FFFBEB',
  border: '1px solid #FDE68A',
  borderRadius: '12px',
  padding: '16px 20px',
  width: '100%',
  maxWidth: '620px',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  marginBottom: '28px',
})

export const FormImportantCardIconWrapper = styled('div')({
  flexShrink: 0,
  width: '20px',
  height: '20px',
})

export const FormImportantCardTitle = styled('div')({
  fontWeight: '600',
  fontSize: '14px',
  color: '#92400E',
  marginBottom: '4px',
})

export const FormImportantCardText = styled('div')({
  fontSize: '13px',
  color: '#B45309',
  lineHeight: '1.6',
})

// --- Form Interview ---

export const FormInterviewPageWrapper = styled('div')({
  backgroundColor: '#F1F5FA',
  minHeight: '100vh',
  overflowX: 'clip',
})

export const FormInterviewStickyHeader = styled(Row)({
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backgroundColor: theme.white,
  padding: '0 20px',
  margin: 0,
})

export const FormInterviewContentRow = styled(Row)({
  margin: '0 clamp(0px, 5vw, 70px)',
})

export const FormInterviewBannerLabelRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
})

export const FormInterviewBannerTitleBlock = styled('div')({
  display: 'block',
  marginTop: '4px',
})

export const FormInterviewBannerSubtitleBlock = styled('div')({
  display: 'block',
  marginTop: '6px',
})

export const FormInterviewProgressRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '8px',
})

export const FormInterviewProgressTrack = styled('div')({
  height: '6px',
  backgroundColor: '#E5EAEF',
  borderRadius: '3px',
  overflow: 'hidden',
})

export const FormInterviewProgressFill = styled('div')(({ percent }) => ({
  height: '100%',
  width: `${percent}%`,
  backgroundColor: theme.talentinoBlue,
  borderRadius: '3px',
  transition: 'width 0.3s ease',
}))

export const FormInterviewQuestionLabelWrapper = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '10px',
  marginBottom: '4px',
})

export const FormInterviewQuestionBadge = styled('div')({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  backgroundColor: '#EEF3FF',
  color: theme.talentinoBlue,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  fontFamily: 'PoppinsSemiBold',
  fontSize: '12px',
})

export const FormInterviewActionBar = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  backgroundColor: theme.white,
  borderRadius: '20px',
  border: `1px solid ${theme.talentinoWhiteBlue}`,
  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.06)',
})

// ── Video Interview Page ───────────────────────────────────────────────────────

export const VideoInterviewBg = styled('div')({
  backgroundColor: '#F1F5FA',
  minHeight: '100vh',
})

export const VideoInterviewPageHeader = styled('div')({
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backgroundColor: theme.white,
  padding: '0 20px',
  display: 'flex',
  alignItems: 'center',
  boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
})

export const VideoInterviewContentWrapper = styled('div')({
  padding: '24px 20px',
  maxWidth: '1300px',
  margin: '0 auto',
})

export const VideoInterviewSideCard = styled('div')({
  backgroundColor: theme.white,
  borderRadius: '12px',
  padding: '16px',
  marginBottom: '16px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
})

export const VideoInterviewSideCardTitle = styled('p')({
  fontSize: '13px',
  fontWeight: '700',
  color: '#374151',
  margin: '0 0 10px',
})

export const VideoInterviewTimerRow = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  padding: '10px 0',
})

export const VideoInterviewTimerValue = styled('span')({
  fontSize: '26px',
  fontWeight: '700',
  color: theme.talentinoBlue,
  letterSpacing: '2px',
})

export const VideoInterviewProgressHeaderRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '8px',
})

export const VideoInterviewProgressLabel = styled('span')({
  fontSize: '13px',
  color: '#6B7280',
})

export const VideoInterviewProgressLabelBold = styled('strong')({
  color: theme.talentinoBlue,
})

export const VideoInterviewProgressRecorded = styled('span')({
  fontSize: '12px',
  color: '#6B7280',
})

export const VideoInterviewBubblesGrid = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  marginTop: '14px',
})

export const VideoInterviewBubble = styled('div')(({ active, completed }) => ({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '13px',
  fontWeight: '600',
  flexShrink: 0,
  border: active ? 'none' : '1.5px solid #D1D5DB',
  backgroundColor: active
    ? theme.talentinoBlue
    : completed
      ? '#EFF6FF'
      : theme.white,
  color: active ? theme.white : completed ? theme.talentinoBlue : '#6B7280',
}))

export const VideoInterviewHintBox = styled('div')({
  marginTop: '14px',
  padding: '10px 12px',
  borderRadius: '8px',
  border: '1px solid #DBEAFE',
  backgroundColor: '#EFF6FF',
  display: 'flex',
  gap: '8px',
  alignItems: 'flex-start',
})

export const VideoInterviewHintText = styled('p')({
  fontSize: '12px',
  color: '#374151',
  margin: 0,
  lineHeight: '1.5',
})

export const VideoInterviewQuestionCard = styled('div')({
  backgroundColor: theme.white,
  borderRadius: '12px',
  padding: '14px 18px',
  marginTop: '12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
})

export const VideoInterviewQuestionMeta = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
  minWidth: 0,
})

export const VideoInterviewQuestionLabel = styled('span')({
  fontSize: '12px',
  color: '#6B7280',
  fontWeight: '500',
})

export const VideoInterviewQuestionTextRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
})

export const VideoInterviewQuestionTextValue = styled('span')({
  fontSize: '17px',
  fontWeight: '700',
  color: '#111827',
})

export const VideoInterviewVideoCard = styled('div')({
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
})
export const FormInterviewMicButton = styled('button')(({ listening }) => ({
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  backgroundColor: listening ? '#A93C38' : theme.talentinoBlue,
  border: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  flexShrink: 0,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  },
  '&:active': {
    transform: 'scale(0.95)',
  },
  '& svg': {
    display: 'block',
    margin: '0 auto',
  },
}))

export const FormInterviewVoiceHint = styled('span')({
  fontSize: '12px',
  color: '#8A97B0',
  whiteSpace: 'nowrap',
})
export const ScheduledInfoContainer = styled('div')(() => ({
  width: '100%',
  maxWidth: 'min(420px, 90vw)',
  marginTop: '0.5rem',
}))

export const ScheduledInfoBox = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px 16px',
  backgroundColor: '#ffffff',
  border: '1px solid #E9F1F6',
  borderRadius: '8px',
  marginTop: '12px',
  width: '100%',
  justifyContent: 'flex-start',
  textAlign: 'left',
}))

export const ScheduledInfoBoxIcon = styled('div')(() => ({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
}))

export const ScheduledInfoBoxText = styled('div')(() => ({
  fontSize: '14px',
  color: '#2c3e50',
  fontWeight: '500',
  flex: 1,
}))

export const ScheduledDetailsBox = styled('div')(() => ({
  padding: '12px 16px',
  backgroundColor: '#ffffff',
  border: '1px solid #E9F1F6',
  borderRadius: '8px',
  marginTop: '12px',
  borderLeft: `3px solid ${theme.success}`,
  textAlign: 'left',
}))

export const ScheduledDetailsLabel = styled('div')(() => ({
  fontSize: '12px',
  color: '#6B7280',
  fontWeight: '600',
  marginBottom: '4px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
}))

export const ScheduledDetailsText = styled('div')(() => ({
  fontSize: '13px',
  color: '#2c3e50',
  lineHeight: '1.5',
}))
